export default __webpack_public_path__ + "static/media/edited-15.2350db65.jpg";